import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Privilege.scss';
import LinearGradient from '@hfe/max-linear-gradient';
function Privilege(p) {
    return <View className="privilege-container">
      <LinearGradient className="privilege-label-container" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={['#FFBB00', '#FFDC00']}>
        <Text className="privilege-label">{p.label}</Text>
      </LinearGradient>
      <Text className="privilege-desc" numberOfLines={1}>{p.desc}</Text>
    </View>;
}
export default memo(Privilege);
